module.exports = [
  require('./snakeFalseWorship'),
  ...require('./godDendarOnly'),
  ...require('./godMerrshaulkOnly'),
  ...require('./godSsethOnly'),
]
